import React, { useEffect } from 'react'
import styled from 'styled-components'
import { numericalFormatter } from '../../utils/num'
import { Wei } from '../../utils/types'
import NumericalValue from '../NumericalValue'
import { swaapGreen0, swaapRed0 } from '../Themes'
import { fromWei } from '../../utils/static-web3'
import { Loader } from '../Loader'
import { precise3 } from '../../logic/financials/precise'

const PanelCurrencyBalanceTitle = styled.div`
  font-size: 14px;
  text-align: left;
  align-self: center;
  justify-content: left;
`

const PanelCurrencyBalanceValue = styled(NumericalValue)<{
  enoughBalance: boolean | undefined
}>`
  font-family: Montserrat-Medium, Montserrat;
  font-size: 14px;
  text-align: left;
  align-self: center;
  margin-left: 0.3em;
  justify-content: left;
  color: ${({ enoughBalance, theme }) =>
    enoughBalance !== undefined
      ? enoughBalance
        ? 'inherited'
        : swaapRed0
      : theme.tradeCurrencyTextColor};
  opacity: 0.5;
  font-weight: bold;
`

const _PanelCurrencyBalance = styled.div`
  pointer-events: auto;
  font-size: 0.5em;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
`
interface Props {
  exceed?: boolean
  balance: Wei | undefined
  decimals: number
  loading: boolean
}
function PanelCurrencyBalance({
  balance,
  decimals,
  loading,
  exceed = false,
}: Props) {
  const isPositive = balance && Number(balance) > 0
  return (
    <>
      {!loading ? (
        <_PanelCurrencyBalance>
          <PanelCurrencyBalanceTitle>Balance:</PanelCurrencyBalanceTitle>
          <PanelCurrencyBalanceValue
            enoughBalance={!exceed}
            data-cy={exceed ? 'exceed-balance' : 'balance'}
          >
            {isPositive ? numericalFormatter(fromWei(balance, decimals)) : 0}
          </PanelCurrencyBalanceValue>
        </_PanelCurrencyBalance>
      ) : (
        <Loader size={'20px'} />
      )}
    </>
  )
}
export default PanelCurrencyBalance
